
const HeroVideo = {

	init: function (videoElement) {

		const video = videoElement;
		if (video && Hls.isSupported()) {
			const hls = new Hls();
			hls.loadSource(video.dataset.videoUrl);
			hls.attachMedia(video);
			video.play();
		} else if (video && video.canPlayType('application/vnd.apple.mpegurl')) {
			video.src = video.dataset.videoUrl;
			video.play();
		} else if (video) {
			console.warn('HLS is not supported for this browser');
		}
	}

};

export default HeroVideo;
